var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/goodsList" } } },
                [_c("div", { staticClass: "div1" }, [_vm._v("商品列表")])]
              ),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [
                  _vm._v(_vm._s(_vm.breadcrumbTitle)),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("基础信息")]),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              attrs: {
                model: _vm.infoForm,
                rules: _vm.infoRules,
                "label-width": "110px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "商品分类" } }, [
                _c("div", { staticClass: "goods-category-edit" }, [
                  _c("span", [_vm._v(_vm._s(_vm.categoryArrStr))]),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "商品类型", prop: "goodsType" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.infoForm.goodsTypes,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "goodsTypes", $$v)
                        },
                        expression: "infoForm.goodsTypes",
                      },
                    },
                    _vm._l(_vm.dictionaries.goods_type, function (item, index) {
                      return _c(
                        "el-checkbox",
                        { key: index, attrs: { label: item.dictId } },
                        [_vm._v(_vm._s(item.dictName))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "830px" },
                  attrs: { label: "商品名称", prop: "name" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入商品名称",
                      maxlength: "30",
                      "show-word-limit": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.infoForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "name", $$v)
                      },
                      expression: "infoForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { display: "flex", height: "61px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "外部商品", prop: "isOut" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { width: "205px" },
                          model: {
                            value: _vm.infoForm.isOut,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoForm, "isOut", $$v)
                            },
                            expression: "infoForm.isOut",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "500px" },
                      attrs: { label: "商品外部编号" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入商品外部编号",
                          maxlength: "24",
                          "show-word-limit": "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.infoForm.outGoodsNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "outGoodsNo", $$v)
                          },
                          expression: "infoForm.outGoodsNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标签", prop: "tagList" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "labelbox",
                      staticStyle: { "flex-wrap": "wrap" },
                    },
                    [
                      _vm._l(_vm.seletedTag, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: "dd" + item.id,
                            staticClass: "labelitem",
                            staticStyle: { "margin-bottom": "10px" },
                          },
                          [
                            _vm._v(" " + _vm._s(item.tagName) + " "),
                            _vm.currentPageStatus !== "details"
                              ? _c("i", {
                                  staticClass: "el-icon-circle-close labelicon",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteTag(index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      _vm.currentPageStatus !== "details"
                        ? _c(
                            "div",
                            {
                              staticClass: "primary-button",
                              on: {
                                click: function ($event) {
                                  return _vm.addTag()
                                },
                              },
                            },
                            [_vm._v(" 添加标签 ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm.infoForm.goodsNo
                ? _c(
                    "el-form-item",
                    { staticClass: "goods-no", attrs: { label: "商品编码" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.infoForm.goodsNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "goodsNo", $$v)
                          },
                          expression: "infoForm.goodsNo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "brand-id",
                  attrs: { label: "品牌", prop: "brandId" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择所属品牌",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.infoForm.brandId,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "brandId", $$v)
                        },
                        expression: "infoForm.brandId",
                      },
                    },
                    _vm._l(_vm.brandList, function (item, index) {
                      return _c("el-option", {
                        key: index + item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content attr" }, [
        _c("div", { staticClass: "attr-title" }, [_vm._v("类目属性")]),
        _c(
          "div",
          { staticClass: "attr-content" },
          [
            _c("h4", [_vm._v("商品属性")]),
            _vm._l(_vm.goodsAttrData, function (item, index) {
              return [
                _c("h5", [_vm._v(_vm._s(item.name))]),
                _c(
                  "div",
                  { staticClass: "attr-list" },
                  [
                    _c("form-filed", {
                      ref: "formAttr" + item.id,
                      refInFor: true,
                      attrs: {
                        formconfig: item.formconfig,
                        formData: item.formData,
                      },
                      on: { formDataval: _vm.dialogClick },
                    }),
                  ],
                  1
                ),
              ]
            }),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "content image-text-form" },
        [
          _vm._m(1),
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "运费设置" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "40%" },
                      on: { change: _vm.selectModel },
                      model: {
                        value: _vm.infoForm.shippingTemplateId,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "shippingTemplateId", $$v)
                        },
                        expression: "infoForm.shippingTemplateId",
                      },
                    },
                    _vm._l(_vm.models, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.isShowTemplate
                ? _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _vm.detail.calculType == 1
                        ? _c("number", {
                            key: Math.random(),
                            attrs: {
                              isEdit: false,
                              tableData: _vm.tableData,
                              freight: _vm.detail.freight,
                              baseNumber: _vm.detail.baseNumber,
                              addNum: _vm.detail.addNum,
                              addPrice: _vm.detail.addPrice,
                            },
                          })
                        : _vm._e(),
                      _vm.detail.calculType == 2
                        ? _c("weight", {
                            key: Math.random(),
                            attrs: {
                              tableData: _vm.tableData,
                              freight: _vm.detail.freight,
                              baseNumber: _vm.detail.baseNumber,
                              addNum: _vm.detail.addNum,
                              addPrice: _vm.detail.addPrice,
                              isEdit: false,
                            },
                          })
                        : _vm._e(),
                      _vm.tableDataF.length != 0
                        ? _c("free-delivery", {
                            staticStyle: { "margin-top": "10px" },
                            attrs: { tableData: _vm.tableDataF, isEdit: false },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content image-text-form" },
        [
          _c("h3", [_vm._v("图文信息")]),
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品图片(0/10)" } },
                [
                  _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("商品图片(" + _vm._s(_vm.fileList.length) + "/10)"),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "17px",
                        "font-size": "12px",
                        "font-family": "PingFang SC",
                        "font-weight": "400",
                        "line-height": "17px",
                        color: "#999999",
                        opacity: "1",
                        "margin-bottom": "8px",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _vm._v(
                        " 图片尺寸：建议上传750px*750px，每张上传大小不得超过8M,支持jpg、png格式 "
                      ),
                    ]
                  ),
                  _c("upload-picture", {
                    attrs: { limit: 10, list: _vm.fileList },
                    on: { changeImage: _vm.changeImage },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品详情" } },
                [
                  _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("商品详情"),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "17px",
                        "font-size": "12px",
                        "font-family": "PingFang SC",
                        "font-weight": "400",
                        "line-height": "17px",
                        color: "#999999",
                        opacity: "1",
                        "margin-bottom": "8px",
                        "margin-top": "12px",
                      },
                    },
                    [
                      _vm._v(
                        " 若批量上传，建议一次不过20张，且每张大小不超过8M，支持jpg，png格式 "
                      ),
                    ]
                  ),
                  _c("quill-editor", {
                    ref: "myQuillEditor",
                    staticClass: "editor",
                    attrs: { options: _vm.editorOption },
                    model: {
                      value: _vm.infoForm.details,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "details", $$v)
                      },
                      expression: "infoForm.details",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "bottom", staticStyle: { display: "none" } },
                    [
                      _c("el-upload", {
                        ref: "uploadicon",
                        staticClass: "centerImg",
                        attrs: {
                          action: " ",
                          "list-type": "picture-card",
                          "auto-upload": true,
                          multiple: "",
                          "before-upload": _vm.beforeUpload,
                          "http-request": _vm.uploadFile,
                          "on-change": _vm.handleChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content", attrs: { id: "sku-content" } }, [
        _c("h3", [_vm._v("价格库存")]),
        _c("div", { staticClass: "sku-box" }, [
          _vm._m(2),
          _c("div", { staticClass: "sku-content-box" }, [
            _c(
              "div",
              { staticClass: "goods-sale" },
              [
                _vm.currentPageStatus === "add"
                  ? _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择",
                          multiple: "",
                          "collapse-tags": "",
                          "multiple-limit": 3,
                          disabled: _vm.currentPageStatus !== "add",
                        },
                        on: { change: _vm.onChangeGoodsSaleDataListValue },
                        model: {
                          value: _vm.goodsSaleDataListValue,
                          callback: function ($$v) {
                            _vm.goodsSaleDataListValue = $$v
                          },
                          expression: "goodsSaleDataListValue",
                        },
                      },
                      _vm._l(
                        _vm.skuFormConfig.sourceAttribute,
                        function (item) {
                          return _c("el-option", {
                            key: item.name,
                            attrs: { label: item.name, value: item.id },
                          })
                        }
                      ),
                      1
                    )
                  : _vm._e(),
                _vm.skuFormConfig.attribute.length < 3
                  ? [
                      !_vm.inputVisible && _vm.currentPageStatus === "add"
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled:
                                  _vm.skuFormConfig.attribute.length > 2,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showInput()
                                },
                              },
                            },
                            [_vm._v("添加规格")]
                          )
                        : _vm._e(),
                      _vm.inputVisible
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled:
                                  _vm.skuFormConfig.attribute.length > 2,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addSpecName()
                                },
                              },
                            },
                            [_vm._v("确认添加")]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "choose-attribute" },
                  [
                    _vm._l(
                      _vm.skuFormConfig.attribute,
                      function (k, fatherIndex) {
                        return [
                          _c(
                            "h5",
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  placeholder: "+ 自定义规格名称",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.changeInput()
                                  },
                                  blur: function ($event) {
                                    return _vm.changeAttributeTitle(
                                      k.name,
                                      fatherIndex
                                    )
                                  },
                                  focus: function ($event) {
                                    return _vm.changeAttributeTitleFocus(
                                      k.name,
                                      fatherIndex
                                    )
                                  },
                                },
                                model: {
                                  value: k.name,
                                  callback: function ($$v) {
                                    _vm.$set(k, "name", $$v)
                                  },
                                  expression: "k.name",
                                },
                              }),
                              _vm.currentPageStatus === "add"
                                ? _c("i", {
                                    staticClass: "el-icon-circle-close",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDeleteContent(
                                          fatherIndex,
                                          _vm.childrenIndex,
                                          "father"
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _c("hr"),
                              _c("span", [_vm._v("规格值")]),
                              _c("span", [
                                _vm._v(
                                  "（已选 " + _vm._s(k.item.length) + "）"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "choose-attribute-list" },
                            [
                              _vm._l(k.item, function (tag, childrenIndex) {
                                return [
                                  _vm.skuFormConfig.attribute[fatherIndex]
                                    .itemList[childrenIndex]
                                    ? [
                                        _vm.skuFormConfig.attribute[fatherIndex]
                                          .itemList[childrenIndex].content
                                          ? _c("el-input", {
                                              key: childrenIndex,
                                              attrs: { size: "small" },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.changeInput()
                                                },
                                                change: function ($event) {
                                                  return _vm.onChangeContent(
                                                    fatherIndex,
                                                    childrenIndex
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.skuFormConfig.attribute[
                                                    fatherIndex
                                                  ].itemList[childrenIndex]
                                                    .content,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.skuFormConfig.attribute[
                                                      fatherIndex
                                                    ].itemList[childrenIndex],
                                                    "content",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "skuFormConfig.attribute[fatherIndex].itemList[\n                      childrenIndex\n                    ].content\n                      ",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.currentPageStatus === "edit" &&
                                        childrenIndex + 1 > _vm.skuList.length
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-circle-close",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDeleteContent(
                                                    fatherIndex,
                                                    childrenIndex
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                ]
                              }),
                              _vm.infoForm.platformId == 0
                                ? _c(
                                    "el-input",
                                    {
                                      ref: "saveTagInput",
                                      refInFor: true,
                                      staticClass: "input-new-tag",
                                      attrs: {
                                        size: "small",
                                        placeholder: "+ 自定义规格值",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.handleInputConfirm(
                                            fatherIndex
                                          )
                                        },
                                        focus: function ($event) {
                                          return _vm.onFocus(fatherIndex)
                                        },
                                        input: function ($event) {
                                          return _vm.changeInput()
                                        },
                                      },
                                      nativeOn: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.handleInputConfirm(
                                            fatherIndex
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.skuFormConfig.inputValueArrTemp[
                                            fatherIndex
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.skuFormConfig.inputValueArrTemp,
                                            fatherIndex,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "skuFormConfig.inputValueArrTemp[fatherIndex]",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          slot: "append",
                                          icon: "el-icon-check",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleInputConfirm(
                                              fatherIndex,
                                              "1"
                                            )
                                          },
                                        },
                                        slot: "append",
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      }
                    ),
                    _vm.skuFormConfig.attribute.length < 3
                      ? [
                          _vm.inputVisible
                            ? _c(
                                "h5",
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder: "+ 自定义规格名称",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.changeInput()
                                      },
                                    },
                                    model: {
                                      value: _vm.specNameTemp.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.specNameTemp, "name", $$v)
                                      },
                                      expression: "specNameTemp.name",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.inputVisible
                            ? _c(
                                "div",
                                { staticClass: "choose-attribute-list" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder: "+ 自定义规格值",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.changeInput()
                                      },
                                    },
                                    model: {
                                      value: _vm.specNameTemp.item,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.specNameTemp, "item", $$v)
                                      },
                                      expression: "specNameTemp.item",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              2
            ),
            _c(
              "div",
              [_c("batchInput", { on: { dealData: _vm.batchSetPrice } })],
              1
            ),
            _c(
              "div",
              { staticClass: "goods-sale-list" },
              [
                _vm.skuFormConfig.attribute.length !== 0
                  ? _c("SkuForm", {
                      ref: "skuForm",
                      attrs: {
                        "source-attribute": _vm.skuFormConfig.sourceAttribute,
                        attribute: _vm.skuFormConfig.attribute,
                        sku: _vm.skuFormConfig.sku,
                        disabled: _vm.skuFormConfig.showForm,
                        structure: _vm.skuFormConfig.structure,
                      },
                      on: {
                        "update:attribute": function ($event) {
                          return _vm.$set(
                            _vm.skuFormConfig,
                            "attribute",
                            $event
                          )
                        },
                        "update:sku": function ($event) {
                          return _vm.$set(_vm.skuFormConfig, "sku", $event)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "skuNo",
                            fn: function (slotSkuNo) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      slotSkuNo.row.skuNo
                                        ? slotSkuNo.row.skuNo
                                        : "- -"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "image",
                            fn: function (slotImg) {
                              return [
                                _c("mall-picture", {
                                  attrs: { imageUrl: slotImg.row.image },
                                  on: {
                                    getUrl: function ($event) {
                                      return _vm.getImage($event, slotImg)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "marketPrice",
                            fn: function (slotProps) {
                              return [
                                slotProps.row.skuNo
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "elInput",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDialog(
                                              "marketPrice",
                                              slotProps.row,
                                              slotProps.$index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "price" }, [
                                          _vm._v(
                                            _vm._s(slotProps.row.marketPrice)
                                          ),
                                        ]),
                                        _c("div", { staticClass: "iconI" }, [
                                          _c("i", {
                                            staticClass: "el-icon-arrow-down",
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入市场价",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeM(
                                                "marketPrice",
                                                slotProps.$index
                                              )
                                            },
                                          },
                                          model: {
                                            value: slotProps.row.marketPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                slotProps.row,
                                                "marketPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "slotProps.row.marketPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                          {
                            key: "retailPrice",
                            fn: function (slotProps) {
                              return [
                                slotProps.row.skuNo
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "elInput",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDialog(
                                              "retailPrice",
                                              slotProps.row,
                                              slotProps.$index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "price" }, [
                                          _vm._v(
                                            _vm._s(slotProps.row.retailPrice)
                                          ),
                                        ]),
                                        _c("div", { staticClass: "iconI" }, [
                                          _c("i", {
                                            staticClass: "el-icon-arrow-down",
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入零售价",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeM(
                                                "retailPrice",
                                                slotProps.$index
                                              )
                                            },
                                          },
                                          model: {
                                            value: slotProps.row.retailPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                slotProps.row,
                                                "retailPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "slotProps.row.retailPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                          {
                            key: "purchasePrice",
                            fn: function (slotProps) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "elInput",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDialog(
                                          "purchasePrice",
                                          slotProps.row,
                                          slotProps.$index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "price" }, [
                                      _vm._v(
                                        _vm._s(slotProps.row.purchasePrice)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "iconI" }, [
                                      _c("i", {
                                        staticClass: "el-icon-arrow-down",
                                      }),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "settlementPrice",
                            fn: function (slotProps) {
                              return [
                                slotProps.row.skuNo
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "elInput",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDialog(
                                              "settlementPrice",
                                              slotProps.row,
                                              slotProps.$index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "price" }, [
                                          _vm._v(
                                            _vm._s(
                                              slotProps.row.settlementPrice
                                            )
                                          ),
                                        ]),
                                        _c("div", { staticClass: "iconI" }, [
                                          _c("i", {
                                            staticClass: "el-icon-arrow-down",
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入结算价",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeM(
                                                "settlementPrice",
                                                slotProps.$index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              slotProps.row.settlementPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                slotProps.row,
                                                "settlementPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "slotProps.row.settlementPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                          {
                            key: "stock",
                            fn: function (slotProps) {
                              return [
                                slotProps.row.skuNo
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "elInput",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDialog(
                                              "stock",
                                              slotProps.row,
                                              slotProps.$index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "price" }, [
                                          _vm._v(_vm._s(slotProps.row.stock)),
                                        ]),
                                        _c("div", { staticClass: "iconI" }, [
                                          _c("i", {
                                            staticClass: "el-icon-arrow-down",
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入库存",
                                          },
                                          model: {
                                            value: slotProps.row.stock,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                slotProps.row,
                                                "stock",
                                                $$v
                                              )
                                            },
                                            expression: "slotProps.row.stock",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                          {
                            key: "status",
                            fn: function (slotProps) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": "1",
                                    "inactive-value": "0",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.openDialog(
                                        "status",
                                        slotProps.row,
                                        slotProps.$index
                                      )
                                    },
                                  },
                                  model: {
                                    value: slotProps.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(slotProps.row, "status", $$v)
                                    },
                                    expression: "slotProps.row.status",
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "bindingSkuNo",
                            fn: function (slotBindingSkuNo) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDialogSkuVisible(
                                          $event,
                                          slotBindingSkuNo
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("手动绑定SKU")]
                                ),
                              ]
                            },
                          },
                          {
                            key: "relationSku",
                            fn: function (slotBindingGoods) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDialogGoodsVisible(
                                          $event,
                                          slotBindingGoods.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("绑定关联商品")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3453642765
                      ),
                    })
                  : _vm._e(),
                _vm.goodsL && _vm.goodsL.length != 0
                  ? _c(
                      "div",
                      { staticStyle: { "margin-top": "20px" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#333333",
                              "font-size": "14px",
                            },
                          },
                          [_vm._v("关联商品")]
                        ),
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "50%", "margin-top": "20px" },
                            attrs: {
                              border: "",
                              data: _vm.goodsL,
                              "span-method": _vm.objectSpanMethod1,
                              "header-cell-style": {
                                "text-align": "center",
                                background: "#F8F8F8",
                                color: "#333333",
                              },
                              "cell-style": { "text-align": "center" },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "skuName",
                                label: "原商品规格",
                                width: "150",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "name", label: "绑定的商品名称" },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "bindGoodsSku", label: "绑定SKU" },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "status", label: "商品规格状态" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.status == 1
                                          ? _c("div", [_vm._v("已上架")])
                                          : _vm._e(),
                                        scope.row.status == 0
                                          ? _c("div", [_vm._v("已下架")])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1198591828
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goodsQuantity",
                                label: "绑定数量",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          [
            _c(
              "el-form",
              { attrs: { "label-width": "100px" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "上架平台", prop: "platformIds" } },
                  [
                    _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(" 上架平台"),
                    ]),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { indeterminate: _vm.isIndeterminate },
                        on: { change: _vm.handleCheckAllChange },
                        model: {
                          value: _vm.checkAll,
                          callback: function ($$v) {
                            _vm.checkAll = $$v
                          },
                          expression: "checkAll",
                        },
                      },
                      [_vm._v("全选(未选平台，默认五域上架)")]
                    ),
                    _c(
                      "el-checkbox-group",
                      {
                        on: { change: _vm.handleCheckedplatformChange },
                        model: {
                          value: _vm.infoForm.platformIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "platformIds", $$v)
                          },
                          expression: "infoForm.platformIds",
                        },
                      },
                      _vm._l(_vm.platforms, function (item) {
                        return _c(
                          "el-checkbox",
                          {
                            key: item.platformId,
                            attrs: { label: item.platformId },
                          },
                          [_vm._v(_vm._s(item.platformName))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm.skuList.length < _vm.skuFormConfig.sku.length
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "平台是否审核上架" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: { "line-height": "20px" },
                            attrs: { slot: "label" },
                            slot: "label",
                          },
                          [
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("*"),
                            ]),
                            _vm._v("平台是否审核上架 "),
                          ]
                        ),
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.selectIsUp },
                            model: {
                              value: _vm.infoForm.isVerifyShelves,
                              callback: function ($$v) {
                                _vm.$set(_vm.infoForm, "isVerifyShelves", $$v)
                              },
                              expression: "infoForm.isVerifyShelves",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.is_verify_shelves,
                            function (item) {
                              return _c(
                                "el-radio",
                                {
                                  key: item.dictId,
                                  attrs: {
                                    value: item.dictId,
                                    label: item.dictId,
                                    name: item.dictName,
                                  },
                                },
                                [
                                  _vm._v(_vm._s(item.dictName)),
                                  item.dictId == 1
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content: "平台手动审核商品是否上架",
                                            placement: "top-start",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  item.dictId == 2
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "五域设定该商品直接在所选平台中售卖",
                                            placement: "top-start",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.infoForm.isVerifyShelves == 2 &&
                _vm.showPlatform.length != 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-left": "220px",
                          "margin-top": "-20px",
                          width: "710px",
                          height: "auto",
                          background: "#f1f6ff",
                          opacity: "1",
                          "border-radius": "0px",
                          "padding-left": "12px",
                          "padding-top": "12px",
                          "padding-bottom": "12px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              "font-family": "PingFang SC",
                              "font-weight": "400",
                              "line-height": "20px",
                              color: "#333333",
                            },
                          },
                          [
                            _vm._v(" 该商品直接上架平台"),
                            _vm.showPlatform.length != 0
                              ? _c("span", [_vm._v("【")])
                              : _vm._e(),
                            _vm._l(_vm.showPlatform, function (item, index) {
                              return _c(
                                "span",
                                { key: index, staticStyle: { color: "red" } },
                                [
                                  index > 0
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("，")]
                                      )
                                    : _vm._e(),
                                  _vm._v(_vm._s(item.name)),
                                ]
                              )
                            }),
                            _vm.showPlatform.length != 0
                              ? _c("span", [_vm._v("】")])
                              : _vm._e(),
                            _vm._v(
                              "平台的【收益】出现亏损！请重新选择上架平台 "
                            ),
                          ],
                          2
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "72px",
                              height: "24px",
                              background: "#ffffff",
                              border: "1px solid #4168e7",
                              opacity: "1",
                              "border-radius": "3px",
                              "font-size": "14px",
                              "font-family": "PingFang SC",
                              "font-weight": "400",
                              "line-height": "24px",
                              color: "#4168e7",
                              "text-align": "center",
                              "margin-top": "10px",
                            },
                            on: { click: _vm.qx },
                          },
                          [_vm._v(" 一键取消 ")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否上架后续新增平台" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: { "line-height": "20px" },
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v("是否上架后续新增平台 "),
                      ]
                    ),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.infoForm.isShelvesAddedPlatform,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.infoForm,
                              "isShelvesAddedPlatform",
                              $$v
                            )
                          },
                          expression: "infoForm.isShelvesAddedPlatform",
                        },
                      },
                      _vm._l(
                        _vm.dictionaries.is_shelves_added_platform,
                        function (item) {
                          return _c(
                            "el-radio",
                            {
                              key: item.dictId,
                              attrs: {
                                value: item.dictId,
                                label: item.dictId,
                                name: item.dictId,
                              },
                            },
                            [_vm._v(" " + _vm._s(item.dictName) + " ")]
                          )
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content bottom-but" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "warning" },
              on: {
                click: function ($event) {
                  return _vm.toOtherPages("goodsList")
                },
              },
            },
            [_vm._v("返回")]
          ),
          _vm.parArray.indexOf("eidt_chengbenjia") != -1
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled:
                      _vm.showPlatform.length != 0 &&
                      _vm.infoForm.isVerifyShelves == 2,
                  },
                  on: { click: _vm.submitAll },
                },
                [_vm._v(_vm._s(_vm.submitButtonText))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function ($event) {
                  return _vm.importImage()
                },
              },
            },
            [_vm._v("导出商品图片")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加标签",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "loglabelbox" }, [
            _c(
              "div",
              { staticClass: "loglabeltopbox" },
              _vm._l(_vm.tagList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: "dd" + item.id,
                    staticClass: "labelitem",
                    class: [item.select ? "selected" : "notselected"],
                    style: { cursor: item.select ? "not-allowed" : "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.selectTagFn(index)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.tagName) + " ")]
                )
              }),
              0
            ),
            _c("div", { staticClass: "circlebox" }, [
              _vm._v(" 已选 "),
              _c("div", { staticClass: "circle" }, [
                _vm._v(" " + _vm._s(_vm.seletedTag.length) + " "),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "loglabeltopbox",
                staticStyle: { border: "none" },
              },
              _vm._l(_vm.seletedTag, function (item, index) {
                return _c(
                  "div",
                  { key: "dd" + item.id, staticClass: "labelitem labelitemc" },
                  [
                    _vm._v(" " + _vm._s(item.tagName) + " "),
                    _c("i", {
                      staticClass: "el-icon-circle-close labelicon",
                      on: {
                        click: function ($event) {
                          return _vm.deleteTag(index)
                        },
                      },
                    }),
                  ]
                )
              }),
              0
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定SKU",
            visible: _vm.dialogSkuVisible,
            "append-to-body": "",
            width: "32%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSkuVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-left": "30px" } },
            [
              _vm._v(" SKU编码 "),
              _c("el-input", {
                staticStyle: { width: "400px", "margin-left": "15px" },
                attrs: { placeholder: "请输入所需绑定的SKU" },
                model: {
                  value: _vm.bindingSkuNo,
                  callback: function ($$v) {
                    _vm.bindingSkuNo = $$v
                  },
                  expression: "bindingSkuNo",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: {
                "margin-left": "106px",
                color: "#f33f3f",
                "font-size": "12px",
              },
            },
            [_vm._v("请留意新旧商品规格是否一致")]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogSkuVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.bindSku } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择标签",
            visible: _vm.showTagDialog,
            width: "1010px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showTagDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "tag—table-box" },
            [
              _c(
                "el-form",
                {
                  ref: "tagForm",
                  attrs: {
                    model: _vm.tagForm,
                    inline: true,
                    id: "search",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "标签", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "标签名称" },
                        model: {
                          value: _vm.tagForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.tagForm, "name", $$v)
                          },
                          expression: "tagForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "类目", prop: "tagClass" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择类目", clearable: "" },
                          model: {
                            value: _vm.tagForm.tagClass,
                            callback: function ($$v) {
                              _vm.$set(_vm.tagForm, "tagClass", $$v)
                            },
                            expression: "tagForm.tagClass",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.goods_tag_class,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticClass: "primary-mini",
                        on: {
                          click: function ($event) {
                            return _vm.fetchData()
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "primary-mini",
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ]),
                ],
                1
              ),
              _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                _c(
                  "div",
                  {
                    staticClass: "primary-plain",
                    on: {
                      click: function ($event) {
                        return _vm.batchSelectTag(1)
                      },
                    },
                  },
                  [_vm._v("批量选择")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "primary-plain",
                    on: {
                      click: function ($event) {
                        return _vm.batchSelectTag(2)
                      },
                    },
                  },
                  [_vm._v("批量取消")]
                ),
              ]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tagList,
                    "header-cell-style": {
                      background: "#F8F8F8",
                      color: "#333333",
                    },
                    "cell-style": { padding: "0" },
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", { attrs: { type: "selection" } }),
                  _c("el-table-column", {
                    attrs: { label: "标签", prop: "tagName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "排序", prop: "sort" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "标签分类", prop: "typeName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "标签类目", prop: "className" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "是否对外展示", prop: "", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "p",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.showFlag == 1 ? "是" : "否"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", prop: "tagName", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "tag-status" }, [
                              _c("div", {
                                staticClass: "circle1",
                                style: {
                                  "background-color":
                                    scope.row.status == 1 ? "#67c23a" : "red",
                                },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.status == 1 ? "启用" : "停用"
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", prop: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !scope.row.selected
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSelectTag(scope)
                                      },
                                    },
                                  },
                                  [_vm._v("选择")]
                                )
                              : _vm._e(),
                            scope.row.selected
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSelectTag(scope)
                                      },
                                    },
                                  },
                                  [_vm._v("取消")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "20px",
                    "background-color": "#f8f8f8",
                    overflow: "hidden",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _vm.tagList.length > 0
                        ? _c("el-pagination", {
                            attrs: {
                              background: "",
                              "current-page": _vm.labelPageNo,
                              "page-sizes": [10, 20, 50],
                              "page-size": _vm.labelPageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.labelTotalNum,
                            },
                            on: {
                              "size-change": _vm.onSizeChange,
                              "current-change": _vm.onCurrentChange,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  staticClass: "primary-gray",
                  on: {
                    click: function ($event) {
                      _vm.showTagDialog = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "关联商品",
            visible: _vm.isGoods,
            "append-to-body": "",
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isGoods = $event
            },
          },
        },
        [
          _vm._l(_vm.skus, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticStyle: { display: "flex", "justify-content": "start" },
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "margin-bottom": "20px" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "line-height": "30px",
                          "margin-right": "20px",
                        },
                      },
                      [_vm._v("绑定SKU")]
                    ),
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          staticStyle: { width: "232px" },
                          attrs: {
                            placeholder: "请输入绑定的SKU",
                            size: "small",
                            oninput: "value=value.replace(/|[^0-9]/g, '')",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.selectSku($event, index)
                            },
                          },
                          model: {
                            value: item.bindGoodsSku,
                            callback: function ($$v) {
                              _vm.$set(item, "bindGoodsSku", $$v)
                            },
                            expression: "item.bindGoodsSku",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "line-height": "30px",
                        "margin-right": "20px",
                        "margin-left": "20px",
                      },
                    },
                    [_vm._v(" 绑定数量 ")]
                  ),
                  _c(
                    "div",
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: {
                          placeholder: "请输入绑定的数量",
                          size: "small",
                          oninput: "value=value.replace(/|[^0-9]/g, '')",
                        },
                        model: {
                          value: item.goodsQuantity,
                          callback: function ($$v) {
                            _vm.$set(item, "goodsQuantity", $$v)
                          },
                          expression: "item.goodsQuantity",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "red",
                      "line-height": "30px",
                      "margin-left": "20px",
                      cursor: "pointer",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.deleteSku(index)
                      },
                    },
                  },
                  [_vm._v(" 删除 ")]
                ),
              ]
            )
          }),
          _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.addGoodsSku } },
                [_vm._v("增加绑定")]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isGoods = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.bindSkuGoods } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog1.title,
            visible: _vm.dialog1.visible,
            width: _vm.dialog1.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog1, "visible", $event)
            },
          },
        },
        [
          [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        plain: "",
                        type: _vm.isUp === "up" ? "primary" : "info",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.isUpPlatform(1)
                        },
                      },
                    },
                    [_vm._v("已上架平台")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        plain: "",
                        type: _vm.isUp === "down" ? "primary" : "info",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.isUpPlatform(0)
                        },
                      },
                    },
                    [_vm._v("待上架平台")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-search",
                  staticStyle: { "margin-top": "4px" },
                },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "search-form",
                      staticStyle: { "margin-left": "4px" },
                      attrs: { inline: true, size: "small" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "平台名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入平台名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.platformName,
                              callback: function ($$v) {
                                _vm.platformName = $$v
                              },
                              expression: "platformName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "dialog-button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.goodsPlatformPrice()
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  data: _vm.dialog1.list,
                  "span-method": _vm.objectSpanMethod,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "name", label: "平台名称" },
                }),
                _vm.dialog1.type === "marketPrice"
                  ? _c("el-table-column", {
                      attrs: { prop: "marketPrice", label: "市场价" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  attrs: { disabled: scope.row.type == 0 },
                                  model: {
                                    value: scope.row.marketPrice,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "marketPrice", $$v)
                                    },
                                    expression: "scope.row.marketPrice",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2462583378
                      ),
                    })
                  : _vm._e(),
                _vm.dialog1.type === "retailPrice"
                  ? _c("el-table-column", {
                      attrs: { prop: "retailPrice", label: "零售价" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  attrs: { disabled: scope.row.type == 0 },
                                  model: {
                                    value: scope.row.retailPrice,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "retailPrice", $$v)
                                    },
                                    expression: "scope.row.retailPrice",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2391722961
                      ),
                    })
                  : _vm._e(),
                _vm.dialog1.type === "purchasePrice"
                  ? _c("el-table-column", {
                      attrs: { prop: "purchasePrice", label: "内购价" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  attrs: { disabled: scope.row.type == 0 },
                                  model: {
                                    value: scope.row.purchasePrice,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "purchasePrice", $$v)
                                    },
                                    expression: "scope.row.purchasePrice",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4292156253
                      ),
                    })
                  : _vm._e(),
                _vm.dialog1.type === "settlementPrice"
                  ? _c("el-table-column", {
                      attrs: { prop: "settlementPrice", label: "结算价" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  attrs: { disabled: scope.row.type == 0 },
                                  model: {
                                    value: scope.row.settlementPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "settlementPrice",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.settlementPrice",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4279113275
                      ),
                    })
                  : _vm._e(),
                _vm.dialog1.type === "stock"
                  ? _c("el-table-column", {
                      attrs: { prop: "stock", label: "可用库存" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  attrs: { disabled: _vm.platformId !== 0 },
                                  model: {
                                    value: scope.row.store,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "store", $$v)
                                    },
                                    expression: "scope.row.store",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4113971407
                      ),
                    })
                  : _vm._e(),
                _vm.dialog1.type === "status"
                  ? _c("el-table-column", {
                      attrs: { prop: "stock", label: "上下架" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": "1",
                                    "inactive-value": "0",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.controlUp(
                                        scope.row,
                                        scope.$index
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "status", $$v)
                                    },
                                    expression: "scope.row.status",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        123305494
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "dialog-pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": 1,
                    "page-sizes": [10, 20, 30, 40],
                    "page-size": 10,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.dialog1.totalNum,
                  },
                  on: {
                    "size-change": _vm.handleSizeChangeDialog,
                    "current-change": _vm.handleCurrentChangeDialog,
                  },
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "margin-top": "20px",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.submitSingle },
                      },
                      [_vm._v("确定")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑",
            visible: _vm.dialogCategory,
            "append-to-body": "",
            width: "32%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogCategory = $event
            },
          },
        },
        [
          _c("categoryDialog", {
            attrs: { categoryIds: _vm.cIds },
            on: { changeC: _vm.changeC },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.dialogSinfo,
            "append-to-body": "",
            width: "32%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSinfo = $event
            },
          },
        },
        [
          _vm._v(" 是否确认增加【 "),
          _vm._l(_vm.addSku, function (item, index) {
            return _c("span", { key: index, staticStyle: { color: "red" } }, [
              index > 0
                ? _c("span", { staticStyle: { color: "red" } }, [_vm._v("，")])
                : _vm._e(),
              _vm._v(_vm._s(item.sku)),
            ])
          }),
          _vm._v("】商品？ "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogSinfo = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.verificationData },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示信息",
            visible: _vm.isS,
            width: "643px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isS = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              {
                staticClass: "info",
                staticStyle: { "text-align": "left", "margin-left": "60px" },
              },
              [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red", "font-size": "20px" },
                }),
                _c("span", [_vm._v(_vm._s(_vm.msg))]),
              ]
            ),
            _vm.gL.length != 0
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      width: "468px",
                      background: "#F1F6FF",
                      "font-size": "14px",
                      "font-family": "PingFang SC",
                      "font-weight": "400",
                      "line-height": "22px",
                      color: "#333333",
                      "margin-left": "60px",
                      "margin-top": "15px",
                      padding: "12px 10px",
                    },
                  },
                  [
                    _vm._v(" 该商品已被"),
                    _vm.gL.length != 0
                      ? _c("span", { staticStyle: { color: "#2d7edf" } }, [
                          _vm._v("【"),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.gL, function (item, index) {
                      return _c(
                        "span",
                        { key: index, staticStyle: { color: "#4168E7" } },
                        [
                          index > 0
                            ? _c(
                                "span",
                                { staticStyle: { color: "#4168E7" } },
                                [_vm._v("， ")]
                              )
                            : _vm._e(),
                          _vm._v(_vm._s(item)),
                        ]
                      )
                    }),
                    _vm.gL.length != 0
                      ? _c("span", { staticStyle: { color: "#2d7edf" } }, [
                          _vm._v("】"),
                        ])
                      : _vm._e(),
                    _vm._v("关联，若确认下架，则所关联的商品都下架！ "),
                  ],
                  2
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isS = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        return _vm.isSsubmit()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("商品信息")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [
      _c("span", { staticStyle: { color: "#f33f3f" } }, [_vm._v("*")]),
      _vm._v("运费设置"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sku-title" }, [
      _c("i", [_vm._v("*")]),
      _c("span", [_vm._v("商品规格")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }